import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress, Switch } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
// import { FaHotel } from "react-icons/fa";
import { ScrollToTop, isValidRole } from "../../../utils/utils";
import { faImages, faLink } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EnableDisableUtilityConfig from "./EnableDisableUtilityConfig";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import DeleteUtilityConfig from "./DeleteUtilityConfig";
import ImageResolutionTooltip from "../ConfigurationNewHotel/ImageResolutionTooltip";

function UtilityServiceConfiguration() {
    const [utilityConfigList, setUtilityConfigList] = useState([]);
    const [confirmDeleteUtilityRow, setConfirmDeleteUtilityRow] = useState("");
    const [confirmValidate, setConfirmValidate] = useState(false);
    const [deleteUtilityPopUp, setDeleteUtilityPopUp] = useState(false);
    const [editUtilityConfig, setEditUtilityConfig] = useState(false);
    const [editUtilityRowUpdate, setEditUtilityRowUpdate] = useState(false);
    const [createUtilitySuccessMsg, setCreateUtilitySuccessMsg] = useState('');
    const [editUtilitySid, setEditUtilitySid] = useState("");
    const [loader, setLoader] = useState(false);
    const [fileError, setFileError] = useState("");
    const [files, setFiles] = useState('');
    const [fileUrl, setFileUrl] = useState('');
    const [resetData, setResetData] = useState({});
    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [paginationError, setPaginationError] = useState("")
    const [inputPageValue, setInputPageValue] = useState(1)

    const recordsPerPage = 10;
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        control,
        watch
    } = useForm({
        mode: 'onChange',
        defaultValues: { active: true }
    });

    let validPermissionClassName = isValidRole("MASTER_CONFIG_UTILITIES_MODIFY")
    ? ""
    : "btn-disable-permission";

    const utilityThumbnailImage = [
        {
          name: "Utility Thumbnail Image",
          files: 1,
          size: "700 KB",
        //   height: "NA",
        //   width: "NA",
        //   resolution: "NA",
        //   aspect: "NA",
          formats: "JPG, JPEG, PNG",
        }
      ]

    const onSubmit = (data) => {
        if (fileUrl === '') {
            setFileError('Utility Thumbnail is required');
            return;
        }
        if(fileError!==""){
            return;
          }
        const formData = new FormData();
        formData.append('thumbnailImage', files); 
        let method = "POST";
        let url = `/utility?title=${data?.title}&text=${data?.text}&active=${data?.active}`;
        if (editUtilityRowUpdate) {
            method = "PUT"
            url = `/utility?id=${editUtilitySid?.id}&title=${data?.title}&text=${data?.text}&active=${data?.active}`;
        }

        callAPI(url, method, formData)
            .then(function (response) {
                setLoader(false);
                reset({
                    title: '',
                    text: '',
                    active: true,
                });
                setFileUrl('');
                setFiles('');
                setCreateUtilitySuccessMsg(response?.message);
                utilityListApi();
            })
            .catch(function (error) {
                setLoader(false);
                console.warn(error.response?.data?.errorMessage);
            });
    };

    const isUtilityDeletedRef = useRef({
        isUtilityDeletedModalData: null,
        userConformationModalData: null,
    });

    const deleteUtilityConfigPopUpHandler = (row) => {
        setDeleteUtilityPopUp(true);
        const newModalRefData = {
            isUtilityDeletedModalData: {
                row
            },
            userConformationModalData: null,
        };
        isUtilityDeletedRef.current = newModalRefData;
    }

    const deleteUtilityHandler = () => {
        setConfirmValidate(true);
        if (confirmDeleteUtilityRow === "") {
            return
        }

        if (confirmDeleteUtilityRow === `Delete ${isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.title}`) {
            setConfirmValidate(false)
            const { row } = isUtilityDeletedRef.current?.isUtilityDeletedModalData;
            callAPI(`/utility?id=${row?.id}`, "DELETE")
                .then((response) => {
                    let successMessage = response.message
                    const newModalRefData = {
                        isUtilityDeletedModalData: null,
                        userConformationModalData: {
                            successMessage
                        },
                    };
                    isUtilityDeletedRef.current = newModalRefData;
                    utilityListApi();
                })
                .catch((error) => {
                    console.warn(error)
                });
        }
        reset({
            title: '',
            text: '',
            active: true,
        });
        setFileUrl('');
        setFiles('');
    }

    const renderActionIcon = (row) => {
        return (
            isValidRole("MASTER_CONFIG_UTILITIES_MODIFY")?<>
                {!row?.active ? <><Tooltip title="Edit" arrow>
                    <MdModeEditOutline
                        className="edit-icon-enable"
                        onClick={() => { setEditUtilityConfig(true); setEditUtilitySid(row) }}
                    />
                </Tooltip>
                    <Tooltip title="Delete" className="cursor-pointer" arrow>
                        <DeleteIcon
                            className="delete-icon-enable"
                            onClick={() => {
                                deleteUtilityConfigPopUpHandler(row);
                            }}
                        />
                    </Tooltip></> :
                    <>
                        <Tooltip title="Disable to perform actions" arrow>
                            <span><MdModeEditOutline className="edit-icon-disable" /></span>
                        </Tooltip>
                        <Tooltip title="Disable to perform actions" arrow>
                            <DeleteIcon className="delete-icon-disable" />
                        </Tooltip>
                    </>
                }

                <EnableDisableUtilityConfig row={row} setLoader={setLoader} utilityListApi={utilityListApi} />
            </>:<>
            <Tooltip title="Don't have permission to edit">
                <span>
                    <MdModeEditOutline className="edit-icon-disable" arrow />
                </span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete">
                <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
            <Tooltip title="Don't have permission to edit">
                <span>
                <Switch
                name="active"
                disabled={true}
                // onChange={(event) => handleToggleChange(event, props?.row)}
                inputProps={{ "aria-label": "controlled" }}
                value={row.active}
                checked={row.active}
                className={`${row.active === false ? 'switchuser-inactive' : 'switchuser-active'}`}
                />
                </span>
        </Tooltip>
        </>
        );
    };
    
    const columns = [
        { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "title", headerName: "Utility Title", flex: 1 },
        { field: 'text', headerName: 'Description', flex: 1, row: true, renderCell: (row)=><p>{row?.text===""?"N.A":row?.text}</p>},
        { field: 'thumbnailUrl', headerName: 'Utility Thumbnail', flex: 1, row: true, renderCell: (row) => (<img src={row?.thumbnailUrl} alt={row?.id} className="partner-config-img" />), disableSortIcon: true,},
        {
            field: "actionCell",
            row: true,
            headerName: "Actions",
            flex: 0.5,
            renderCell: renderActionIcon,
            sortDirection: false,
            disableSortIcon: true,
        },
    ];

    //Pagination Handle changer
    const onPageChange = (event, value) => {
        setInputPageValue(value)
        setPaginationError("")
        setSelectedPage(value);
    };

    const utilityListApi = () => {
        callAPI(`/search_utility?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST", {})
            .then((response) => {
                setUtilityConfigList(response?.utilityResponse)
                setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
                setPaginationError("")
            })
            .catch((err) => console.warn(err.message));
    };

    useEffect(() => {
        utilityListApi();
    }, [selectedPage]);


    const popupCloseHandler = () => {
        setDeleteUtilityPopUp(false);
    };


    useEffect(() => {
        if (editUtilityConfig) {
            getUtilityListSidHandler();
            setEditUtilityConfig(false);
        }
        ScrollToTop();
        setFileError('');
    }, [editUtilityConfig]);

    const getUtilityListSidHandler = () => {
        callAPI(`/utility?id=${editUtilitySid?.id}`, "GET")
            .then(function (response) {
                const payload = {
                    title: response?.title,
                    text: response?.text,
                    active: response?.active
                };
                setFileUrl(response?.thumbnailUrl);
                reset(payload);
                setResetData(response?.thumbnailUrl)
                setEditUtilityRowUpdate(true);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            });
    }

    const resetLayoutHandler = () => {
        reset();
        setFileUrl(resetData);
        setFileError('');
    }

    const cancelUtilityHandler = () => {
        reset({
            title: '',
            text: '',
            active: true,
        });
        setFileUrl('');
        setFiles('');
        setEditUtilityRowUpdate(false);
        setEditUtilitySid('');
        setEditUtilityConfig(false);
        setFileError('');
    }

    const handleSwitchChange = (checked) => {
        setValue("active", checked);
    };

    const uploadOrDragFileHandler = (fileList) => {
        let bytes = (fileList.size / (1024 * 1024)).toFixed(2);
        setFileUrl(URL.createObjectURL(fileList));
        if (bytes > 700) {
            setFileError('Upload file should be less than 700KB');
            return;
          }
        setFiles(fileList);
        setFileError('');
    }
    const deleteLogoHandler = () => {
        setFiles('');
        setFileUrl('');
        setFileError('');
    };

    return (
        <div className='row config-hotel config-management-form'>
            <div className='col-12 left-column'>
                {loader && <div className="circular-progress"><CircularProgress /></div>}
                <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
                    <div className="row">
                        <div className="left-column-header">
                            <p className="Roboto-Bold">{editUtilityRowUpdate ? 'Edit Utility Service Configuration' : 'Utility Service Configuration'}</p>
                        </div>
                        <div className="col-6">
                            <div className="form-group-hotel">
                                <div className="floating-label">
                                    {/* <FaHotel className="new-hotel-icons" /> */}
                                    <input
                                        id="title"
                                        maxLength={25}
                                        placeholder=""
                                    {...register("title", {
                                      required: "Utility Title Required",
                                    })}
                                    />
                                    <label htmlFor="title">Utility Title</label>
                                </div>
                                {errors.title && (
                                    <small className="required">{errors.title.message}</small>
                                )}
                            </div>
                            <div className="form-group-hotel">
                                <div className="floating-label">
                                    {/* <FaHotel className="new-hotel-icons" /> */}
                                    <input
                                        id="text"
                                        placeholder=""
                                        {...register("text")}
                                    />
                                    <label htmlFor="text">Description</label>
                                </div>
                            </div>
                            <div className="status-switch">
                                <p className="mb-0">Utility Status</p>
                                <label htmlFor="active">{!watch("active") ? "Disabled" : "Enabled"}</label>
                                <Switch
                                    id="active"
                                    className={`form-control border-0 ${!watch("active")
                                        ? "switchuser-inactive"
                                        : "switchuser-active"
                                        }`}
                                    checked={watch("active")}
                                    onChange={handleSwitchChange}
                                    {...register("active")}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            {fileUrl !== "" ? <div className="partner-logo">
                                <img src={fileUrl} alt={fileUrl} />
                                <span onClick={() => deleteLogoHandler()}>X</span>
                            </div>
                                : <FileUploader
                                    name="file"
                                    types={["JPG", "PNG", 'JPEG']}
                                    handleChange={uploadOrDragFileHandler}
                                    classes="drag-file file-upload-bg"
                                    children={
                                        <>
                                            <FontAwesomeIcon icon={faImages} className="fa-lg" />
                                            <p className="drag-text">
                                                Drag and drop logo or
                                                <span> Browse</span>
                                                <br />
                                                To upload <span className="Roboto-Bold text-black">Utility Thumbnail</span> here.
                                                <ImageResolutionTooltip data={utilityThumbnailImage}/>
                                            </p>
                                            {/* <h6> Formats Supported : JPG, JPEG and PNG</h6> */}
                                        </>
                                    }
                                />
                            }

                            {fileError && <p className="required">{fileError}</p>}
                        </div>
                    </div>
                    <div className="text-end mt-3">
                        <button type="button" className="clear-btn me-2" onClick={cancelUtilityHandler}>{editUtilityRowUpdate ? "Cancel" : "Clear All"}</button>
                        {editUtilityRowUpdate && <>
                            <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                        </>}
                        <button type="submit" className={`create-btn ${validPermissionClassName} `}>{editUtilityRowUpdate ? "Update" : "Create"}</button>
                    </div>
                </form>
                <div className="hotel-list">
                    <p><b>Utility Configuration List</b></p>

                    <TableWrapper
                        data={utilityConfigList}
                        columns={columns}
                        noPagination={true}
                        module="partner-config"
                    />
                    <Custom_Paingation
                        selectedPage={selectedPage}
                        totalPageCount={totalPageCount}
                        paginationError={paginationError}
                        inputPageValue={inputPageValue}
                        setSelectedPage={setSelectedPage}
                        setPaginationError={setPaginationError}
                        setInputPageValue={setInputPageValue}
                        onPageChange={onPageChange}
                    />
                </div>
            </div>
            {deleteUtilityPopUp && <DeleteUtilityConfig
                deleteUtilityPopUp={deleteUtilityPopUp}
                isUtilityDeletedRef={isUtilityDeletedRef}
                popupCloseHandler={popupCloseHandler}
                deleteUtilityHandler={deleteUtilityHandler}
                setConfirmDeleteUtilityRow={setConfirmDeleteUtilityRow}
                confirmDeleteUtilityRow={confirmDeleteUtilityRow}
                confirmValidate={confirmValidate}
            />}
            <BasicModal
                popupOpen={createUtilitySuccessMsg !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{createUtilitySuccessMsg}</p>}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setCreateUtilitySuccessMsg(''); setEditUtilityRowUpdate(false); utilityListApi(); },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
        </div>
    )
}

export default UtilityServiceConfiguration;